import axios from 'axios'
import { IhLogUrl,baseUrl,metricUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

// 根据关键字分页查询数据流量日志记录
export function getMobileDatas(params) {
  const url = IhLogUrl + '/mobileDatas'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设置》数据中心', '查询数据流量记录', res)
    }
    return Promise.resolve(res.data)
  })
}

// 获取AI分析类型，设置下的AI分析配置页面使用
export function getAiAnalysisType() {
  const url = baseUrl + '/config/ai/type'
  return axios({
    method: 'get',
    url: url,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设置》AI分析配置', '查询AI分析类型', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询AI配置信息
export function getAiConfig(params) {
  const url = baseUrl + '/config/ai/config'
  return axios({
    method: 'get',
    url: url,
    params:params
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设置》AI分析配置', '查询AI配置信息', res)
    }
    return Promise.resolve(res.data)
  })
}

// 保存AI配置信息
export function saveAiConfig(params) {
  const url = baseUrl + '/config/save/ai/config'
  return axios({
    method: 'post',
    url: url,
    data:params
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设置》AI分析配置', '保存AI配置信息', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询AI分析信息
export function getAiAnalysisData(params) {
  const url = metricUrl + '/ai/analyse/file/page'
  return axios({
    method: 'get',
    url: url,
    params:params
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('监控中心》AI分析', '查询AI分析信息', res)
    }
    return Promise.resolve(res.data)
  })
}

// 获取当前租户的历史AI分析类型，监控中心下的AI分析页面使用
export function getAiAnalysisHistoryType() {
  const url = metricUrl + '/ai/analyse/file/history/analyse/type'
  return axios({
    method: 'get',
    url: url,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('监控中心》AI分析', '查询AI分析类型', res)
    }
    return Promise.resolve(res.data)
  })
}
